module.exports = __webpack_public_path__ + "static/undraw_wallet_aym5.3fadf737.svg";


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/undraw/undraw_wallet_aym5.svg
// module id = 509
// module chunks = 0